export default __webpack_public_path__ + "static/media/12321d9c2f87d0fd6741514c91239d191581620039981.3c8ff8fd.webp";